<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">BLOSUSM62 Matrix</div>
    <img src="assets/images/BlosumMatrix.svg" alt="Blossum62 Matrix" style="width: 100%; max-width: 1200px; margin-top: 30px; border: 3px gray solid;">
</div>